/**
 * Protected Route Component
 * Ensures user is authenticated before accessing routes.
 * Also renders the shared Sidebar so every protected page gets it for free.
 *
 * allowedRoles (optional): if set, redirects away any authenticated user
 * whose role isn't in the list. This is UI convenience only, introduced
 * for the KRA module's HR/CEO/HOD-only screens - the real access control
 * is server-side (see app/auth_dependency.py's get_current_employee /
 * require_role / can_view_employee_kra). Hiding a route here does not
 * substitute for the backend check.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import LoadingSpinner from './LoadingSpinner';
import Sidebar from './Sidebar';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, token, user } = useAuthStore();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!isAuthenticated) {
    return <LoadingSpinner />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <Sidebar />
      <div className="md:ml-64 pt-14 md:pt-0">
        {children}
      </div>
    </>
  );
};

export default ProtectedRoute;
